
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.58 19.82"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(-.62 -.09)"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h20v20H0z"}})])]),_c('g',{attrs:{"data-name":"Grupo de máscara 1697"}},[_c('g',{attrs:{"data-name":"streamline-icon-analytics-pie-2 20x20","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Caminho 3252","d":"M10.53 0a8.06 8.06 0 018 8.05.63.63 0 01-.62.63h-7.38a.63.63 0 01-.62-.63V.63a.63.63 0 01.62-.63zm6.78 7.43a6.82 6.82 0 00-6.15-6.15v6.15z"}}),_c('path',{attrs:{"data-name":"Caminho 3253","d":"M8.06 3.72a.62.62 0 01.62.62v7.21l4.46 5.67a.63.63 0 01-.11.88 8.05 8.05 0 11-5-14.38zm3.69 13.76l-4.18-5.33a.59.59 0 01-.14-.38V4.99a6.8 6.8 0 00.63 13.58 6.89 6.89 0 003.69-1.09z"}}),_c('path',{attrs:{"data-name":"Caminho 3254","d":"M10.53 9.91h7.43a.64.64 0 01.63.63 8.07 8.07 0 01-3.08 6.37.62.62 0 01-.88-.11l-4.59-5.89a.62.62 0 01.11-.87.59.59 0 01.38-.13zm6.78 1.25h-5.49l3.39 4.32a6.74 6.74 0 002.1-4.33z"}})])])])
          )
        }
      }
    